'use client';

import { ReactNode, Ref } from 'react';
import { useState } from 'react';
import { DrawerDialog } from '@/components/core/modals';
import { optionStyle, dropdownContainer, optionsContainer } from './Select.css';
import { Check } from 'lucide-react';

export interface Option {
  value: string;
  label: ReactNode;
}

export type SelectProps = {
  options: Option[];
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  'data-id'?: string;
  ref?: Ref<HTMLDivElement>;
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'>;

export const Select = (props: SelectProps) => {
  const { disabled, options, onChange, value, placeholder = 'Select', ref } = props;
  const dataId = props['data-id'];

  const [visible, setVisible] = useState(false);
  const activeOption = options.find((option) => option.value === value);

  const Options = (
    <div className={dropdownContainer} ref={ref}>
      <div className={optionsContainer}>
        {options.map((option) => (
          <div
            className={optionStyle}
            data-id={dataId ? `${dataId}-option` : undefined}
            key={option.value}
            onClick={() => {
              onChange?.(option.value);
              setVisible(false);
            }}
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <span>{option.label}</span>
            {option.value === value && <Check size={24} color="#34ac68" />}
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <DrawerDialog
      disabled={disabled}
      visible={visible}
      setVisible={setVisible}
      label={(activeOption?.label ?? placeholder).toString()}
      triggerDataId={dataId ? `${dataId}-trigger` : undefined}
    >
      {Options}
    </DrawerDialog>
  );
};
